import { render, staticRenderFns } from "./CreateMedia.vue?vue&type=template&id=1af06a6e&scoped=true"
import script from "./CreateMedia.vue?vue&type=script&lang=js"
export * from "./CreateMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af06a6e",
  null
  
)

export default component.exports